import { render, staticRenderFns } from "./data-table-setting.vue?vue&type=template&id=2860c7e3&scoped=true&lang=pug&"
import script from "./data-table-setting.vue?vue&type=script&lang=ts&"
export * from "./data-table-setting.vue?vue&type=script&lang=ts&"
import style0 from "./data-table-setting.vue?vue&type=style&index=0&id=2860c7e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2860c7e3",
  null
  
)

export default component.exports